module.exports = {
  Component: require('./lib/virtual/Component'),
  html: require('./lib/virtual/html'),
  render: require('./lib/dom/render'),
}



// WEBPACK FOOTER //
// ../node_modules/vqua/index.js